import ModelState from './_util/model';

class currenciesState extends ModelState {
  sanitizeModelId(id) { return parseFloat(id); }

  get url() { return '/currencies'; }
  get singular() { return 'currency'; }
  get plural() { return 'currencies'; }
}

export default currenciesState;



// WEBPACK FOOTER //
// ./spa/state/currencies.jsx